<template>
  <hm-content title="">
    <div class="flex flex-start mb10">
      <el-input
        class="mr10"
        size="small"
        clearable
        placeholder="输入券码"
        v-model.trim="couponCode"
        style="width: 250px"
      ></el-input>
      <el-button size="small" type="primary" @click="search">查询</el-button>
    </div>
    <div>
      <el-table
        stripe
        border
        ref="multipleTable"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="statusName"
          label="券状态"
        >
        </el-table-column>
      </el-table>
    </div>
  </hm-content>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      couponCode: ""
    };
  },
  created() {},
  mounted() {},
  methods: {
    async search() {
      if (this.couponCode) {
        const { result } = await this.$store.dispatch("getCouponInfo", {
          couponCode: this.couponCode
        });
        this.list = result;
      } else {
        this.$message({
          message: "请输入券码",
          type: "warning"
        });
      }
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
